<template>
  <div
    v-scroll-lock="() => true"
    class="modal active"
  >
    <div class="modal-overlay"></div>

    <section class="modal-container modal-form modal-form--md">
      <header class="modal-header modal-form__header">
        <a
          class="btn btn-clear float-right modal-form__close"
          aria-label="close"
          @click="close"
        />

        <h1 class="modal-form__title">
          Desbloquear agenda
        </h1>
      </header>

      <article class="modal-body modal-form__body">
        <p class="modal-form__text modal-form__text--nomargin w-full">
          Escolha abaixo a opção de desbloqueamento:
        </p>

        <ul
          :class="{ 'cursor-not-allowed': loading }"
          class="m-0 p-0 list-none"
        >
          <li :class="{ 'pointer-events-none': loading }">
            <label class="form-radio">
              <input
                v-model="unblockType"
                type="radio"
                value="interval"
              >
              <i class="form-icon" />

              <span class="modal-form__text">
                Desbloquear intervalo de
                <strong style="color: #666">
                  {{ data.start | TO_DATE_TIME }}
                </strong>
                a
                <strong style="color: #666">
                  {{ data.end | TO_DATE_TIME }}
                </strong>
              </span>
            </label>
          </li>

          <li :class="{ 'pointer-events-none': loading }">
            <label class="form-radio">
              <input
                v-model="unblockType"
                type="radio"
                value="office"
              >
              <i class="form-icon" />

              <span class="modal-form__text">
                Desbloquear toda a agenda de
                <strong style="color: #666">
                  {{ data.doctorOffice.name }}
                </strong>
              </span>
            </label>
          </li>
        </ul>
      </article>

      <footer class="modal-form__footer">
        <dr-submit
          :loading="loading"
          :disabled="loading"
          class="appointment-simple__submit"
          text="Desbloquear agenda"
          @click="unblockAgenda"
        />
      </footer>
    </section>
  </div>
</template>

<script>
import DrSubmit from '@/components/form/submit'

export default {
  name: 'AgendaUnblockModal',

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  components: {
    DrSubmit
  },

  data () {
    return {
      localActive: false,
      loading: false,
      unblockType: 'interval'
    }
  },

  methods: {
    close () {
      this.$emit('close')
    },

    unblockAgenda () {
      const url = `/${
        this.fn_GET_PARENT_ROUTE(this.$route)
      }/doctor_office/${
        this.data.doctorOffice.id
      }/agenda/agenda_block${
        this.unblockType === 'interval' ? `/${this.data.id}` : ''
      }`

      this.fn_SHOW_PROGRESS()
      this.loading = true
      this.$http
        .delete(url, this.$store.getters.getAuthHeader)
        .then(() => {
          this.$emit('reload')
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Agenda desbloqueada com sucesso.',
            size: 'md',
            active: true
          })
        })
        .catch((err) => {
          this.fn_HANDLE_ERROR(err)
        })
        .finally(() => {
          this.$emit('close')
          this.loading = false
          this.fn_HIDE_PROGRESS()
        })
    }
  }
}
</script>
